import { render, staticRenderFns } from "./PromptDialog.vue?vue&type=template&id=d5c16f32"
import script from "./PromptDialog.vue?vue&type=script&lang=js"
export * from "./PromptDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports